import React, { Component } from 'react';

import './styles/App.css';

import ConnectedDataDisplay from './containers/ConnectedDataDisplay';
import ConnectedGraphDisplay from './containers/ConnectedGraphDisplay';

class App extends Component {
	render() {
		return (
			<div className="App container">
				<h1>Composite Variable Tool</h1>
				<ConnectedDataDisplay
					fileId="xFile"
					title="X-Coordinate" />
				<ConnectedDataDisplay
					fileId="yFile"
					title="Y-Coordinate" />
				<ConnectedDataDisplay
					fileId="zFile"
					title="Z-Coordinate" />
				<ConnectedGraphDisplay />
				<footer>
					<p>&copy; 2017</p>
				</footer>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js